import React from "react";
import StyleTable from "../../components/ai-avatar/styles/style";

export default function Styles() {
  return <StyleTable />;
}
